export default __webpack_public_path__ + "static/media/heretohelp.60ef9dd3.png";